// List of tools for Editor user
export const EDITOR_TOOL_BUTTONS = [
    {
        type: 'toolGroupButton',
        title: 'annotation.strikeout',
        dataElement: 'strikeoutButton',
        toolGroup: 'strikeoutTools',
    },
    {
        type: 'toolGroupButton',
        title: 'annotation.callout',
        dataElement: 'calloutButton',
        toolGroup: 'calloutTools',
    },
    {
        type: 'toolGroupButton',
        title: 'annotation.freetext',
        dataElement: 'freeTextButton',
        toolGroup: 'freeTextTools',
    },
    {
        type: 'toolGroupButton',
        title: 'annotation.rectangle',
        dataElement: 'shapeButton',
        toolGroup: 'rectangleTools',
    },
    {
        type: 'toolGroupButton',
        title: 'annotation.ellipse',
        dataElement: 'ellipseButton',
        toolGroup: 'ellipseTools',
    },
    {
        type: 'toolGroupButton',
        title: 'annotation.line',
        dataElement: 'lineButton',
        toolGroup: 'lineTools',
    },
    {
        type: 'toolGroupButton',
        title: 'annotation.arrow',
        dataElement: 'arrowButton',
        toolGroup: 'arrowTools',
    },
]

// List of tools for user to annotate IM-DFM
export const IM_DFM_ANNOTATE_TOOL_BUTTONS = [
    ...EDITOR_TOOL_BUTTONS,
    {
        type: 'toolGroupButton',
        title: 'annotation.polyline',
        dataElement: 'polyLineButton',
        toolGroup: 'polyLineTools',
    },
    {
        type: 'toolGroupButton',
        title: 'annotation.polygon',
        dataElement: 'polygonButton',
        toolGroup: 'polygonTools',
    },
]

// List of tools for Scheduler user
export const SCHEDULER_TOOL_BUTTONS = [
    {
        type: 'toolButton',
        title: 'Inspection Point',
        dataElement: 'inspectionPointButton',
        toolName: 'AnnotationCreateInspectionPoint',
    },
    {
        type: 'toolGroupButton',
        title: 'annotation.redact',
        dataElement: 'redactionButton',
        toolGroup: 'redactionTools',
        showColor: 'never',
    },
]

export const DISABLED_TOOLS = [
    // "AnnotationCreateArrow",
    // "AnnotationCreateCallout",
    // "AnnotationCreateEllipse",
    'AnnotationCreateFreeHand',
    // "AnnotationCreateFreeText",
    // "AnnotationCreateLine",
    // 'AnnotationCreatePolygon',
    'AnnotationCreatePolygonCloud',
    // 'AnnotationCreatePolyline',
    // "AnnotationCreateRectangle",
    'AnnotationCreateDistanceMeasurement',
    'AnnotationCreatePerimeterMeasurement',
    'AnnotationCreateAreaMeasurement',
    'AnnotationCreateRectangularAreaMeasurement',
    'AnnotationCreateEllipseMeasurement',
    'AnnotationCreateCountMeasurement',
    'AnnotationCreateSignature',
    'AnnotationCreateStamp',
    'AnnotationCreateFileAttachment',
    'AnnotationCreateRubberStamp',
    'AnnotationCreateSticky',
    'AnnotationCreateTextHighlight',
    'AnnotationCreateTextSquiggly',
    // "AnnotationCreateTextStrikeout",
    'AnnotationCreateTextUnderline',
    // "AnnotationCreateRedaction",
    // "TextSelect",
    // "AnnotationEdit",
    // "Pan",
    // "CropPage",
    // "MarqueeZoomTool",
    // "AnnotationEraserTool",
    'AnnotationCreateFreeHand2',
    'AnnotationCreateFreeHand3',
    'AnnotationCreateFreeHand4',
    'AnnotationCreateTextHighlight2',
    'AnnotationCreateTextHighlight3',
    'AnnotationCreateTextHighlight4',
    'AnnotationCreateFreeText2',
    'AnnotationCreateFreeText3',
    'AnnotationCreateFreeText4',
    'AnnotationCreateCallout2',
    'AnnotationCreateCallout3',
    'AnnotationCreateCallout4',
    'AnnotationCreateSticky2',
    'AnnotationCreateSticky3',
    'AnnotationCreateSticky4',
    'AnnotationCreateTextUnderline2',
    'AnnotationCreateTextUnderline3',
    'AnnotationCreateTextUnderline4',
    'AnnotationCreateTextStrikeout2',
    'AnnotationCreateTextStrikeout3',
    'AnnotationCreateTextStrikeout4',
    'AnnotationCreateTextSquiggly2',
    'AnnotationCreateTextSquiggly3',
    'AnnotationCreateTextSquiggly4',
    'AnnotationCreateRectangle2',
    'AnnotationCreateRectangle3',
    'AnnotationCreateRectangle4',
    'AnnotationCreateEllipse2',
    'AnnotationCreateEllipse3',
    'AnnotationCreateEllipse4',
    'AnnotationCreatePolygon2',
    'AnnotationCreatePolygon3',
    'AnnotationCreatePolygon4',
    'AnnotationCreatePolygonCloud2',
    'AnnotationCreatePolygonCloud3',
    'AnnotationCreatePolygonCloud4',
    'AnnotationCreateLine2',
    'AnnotationCreateLine3',
    'AnnotationCreateLine4',
    'AnnotationCreatePolyline2',
    'AnnotationCreatePolyline3',
    'AnnotationCreatePolyline4',
    'AnnotationCreateArrow2',
    'AnnotationCreateArrow3',
    'AnnotationCreateArrow4',
    'AnnotationCreateCountMeasurement2',
    'AnnotationCreateCountMeasurement3',
    'AnnotationCreateCountMeasurement4',
    'AnnotationCreateDistanceMeasurement2',
    'AnnotationCreateDistanceMeasurement3',
    'AnnotationCreateDistanceMeasurement4',
    'AnnotationCreatePerimeterMeasurement2',
    'AnnotationCreatePerimeterMeasurement3',
    'AnnotationCreatePerimeterMeasurement4',
    'AnnotationCreateAreaMeasurement2',
    'AnnotationCreateAreaMeasurement3',
    'AnnotationCreateAreaMeasurement4',
    'AnnotationCreateEllipseMeasurement2',
    'AnnotationCreateEllipseMeasurement3',
    'AnnotationCreateEllipseMeasurement4',
    'AnnotationCreateRectangularAreaMeasurement2',
    'AnnotationCreateRectangularAreaMeasurement3',
    'AnnotationCreateRectangularAreaMeasurement4',
]

export const FullScreenButton = {
    type: 'actionButton',
    title: 'Fullscreen',
    img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - full screen</title><path class="cls-1" d="M4.22,4.22H9.78V2H2V9.78H4.22ZM9.78,19.78H4.22V14.22H2V22H9.78ZM22,14.22H19.78v5.56H14.22V22H22ZM19.78,9.78H22V2H14.22V4.22h5.56Z"></path></svg>',
    dataElement: 'FullscreenButton',
}

export const DownloadButton = {
    type: 'actionButton',
    title: 'Download',
    img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - download</title><path class="cls-1" d="M11.55,17,5.09,9.66a.6.6,0,0,1,.45-1H8.67V2.6a.6.6,0,0,1,.6-.6h5.46a.6.6,0,0,1,.6.6V8.67h3.13a.6.6,0,0,1,.45,1L12.45,17A.6.6,0,0,1,11.55,17ZM3.11,20.18V21.6a.4.4,0,0,0,.4.4h17a.4.4,0,0,0,.4-.4V20.18a.4.4,0,0,0-.4-.4h-17A.4.4,0,0,0,3.11,20.18Z"></path></svg>',
    dataElement: 'DownloadButton',
}

export const PrintButton = {
    type: 'actionButton',
    title: 'Print',
    img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - print</title><path class="cls-1" d="M20,6H18V2H6V6H4A2,2,0,0,0,2,8v9a2,2,0,0,0,2,2H6v3H18V19h2a2,2,0,0,0,2-2V8A2,2,0,0,0,20,6ZM8,4h8V6H8Zm8,16H8V16h8Zm4-3H18V14H6v3H4V8H20Zm-4-7h2v2H16Zm-3,0h2v2H13Z"></path></svg>',
    dataElement: 'PrintButton',
}

export const ZoomInButton = {
    type: 'actionButton',
    title: 'Zoom In',
    img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - zoom - in - line</title><path class="cls-1" d="M13,11h4v2H13v4H11V13H7V11h4V7h2Zm9,1A10,10,0,1,1,12,2,10,10,0,0,1,22,12Zm-2,0a8,8,0,1,0-8,8A8,8,0,0,0,20,12Z"></path></svg>',
    dataElement: 'customZoomInButton',
}

export const ZoomOutButton = {
    type: 'actionButton',
    title: 'Zoom Out',
    img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - zoom - out - line</title><path class="cls-1" d="M7,11H17v2H7Zm15,1A10,10,0,1,1,12,2,10,10,0,0,1,22,12Zm-2,0a8,8,0,1,0-8,8A8,8,0,0,0,20,12Z"></path></svg>',
    dataElement: 'customZoomOutButton',
}

export const INSPECTION_POINT_BUBBLE = 'InspectionPointBubble'
export const INSPECTION_POINT = 'Inspection point'
export const INSPECTION_POINT_SELECTION = 'InspectionPointSelection'
export const INSPECTION_POINT_SELECTION_AREA = 'Inspection Point Selection'
export const REDACTION_BOXES = 'Redact'

export const ENABLE_HEADER_VIEW_MODE = [
    'viewControlsButton',
    'zoomOverlayButton',
    'viewControlsOverlay',
    'panToolButton',
    'selectToolButton',
    'toggleNotesButton',
    'leftPanelButton',
    'ribbons',
    'searchButton',
]

export const ENABLE_DEFAULT_HEADER_VIEW_MODE = [
    'viewControlsButton',
    'zoomOverlayButton',
    'viewControlsOverlay',
    'panToolButton',
    'selectToolButton',
    'toggleNotesButton',
    'leftPanelButton',
    'ribbons',
    'searchButton',
    'menuButton',
    'viewControlsOverlay',
]

export const ENABLE_HEADER_EDIT_MODE = [
    'viewControlsButton',
    'zoomOverlayButton',
    'viewControlsOverlay',
    'panToolButton',
    'selectToolButton',
    'ribbons',
    'searchButton',
]

export const QUOTE_VIEWER_MODE = [
    'toolsHeader',
    'leftPanelButton',
    'ribbons',
    'selectToolButton',
    'searchButton',
    'toggleNotesButton',
    'menuButton',
]
